"use client";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

export default function PerformanceChart({performanceData}) {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-custom">
      <h2 className="font-medium text-lg md:text-xl mb-2">
        Employee Performance Chart
      </h2>

      <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 mb-4">
        <div className="text-xl md:text-2xl font-semibold">{performanceData.AverageKPI}%</div>
        <div className="bg-green-100 text-[#87CA60] px-2 py-1 rounded-full text-xs md:text-sm">
          ↑ {performanceData.KPIChange  }% increase since last month
        </div>
      </div>

      <div className="h-[200px] sm:h-[250px] md:h-[300px] relative block w-full min-w-0 overflow-hidden">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={performanceData.MonthlyPerformance}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 10 }} />
            <YAxis tick={{ fontSize: 10 }} />
            <Bar dataKey="count" fill="#005787" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
